export enum ChatMessageType {
    NONE =0,
    BOTMESSAGE = 1,
    CLIENTMESSAGE= 2,
    AGENTMESSAGE = 3,
    EVENTMESSAGE = 4
}